import { Stack, Typography } from '@mui/material';
import { researchPaperContent } from 'pages/Welcome/StudyUpdates/constants';
import { Card } from 'pages/Welcome/StudyUpdates/styles';
import { WelcomePageWrapper } from 'pages/Welcome/styles';
import { Link } from 'react-router-dom';

export function StudyUpdates() {
  const { pageTitle, researchPapers, readMore } = researchPaperContent;
  document.title='Single Ventricle SOURCE';
  
  return (
    <>
      <WelcomePageWrapper>
        <Typography display='block' color='primary.navy' variant='h1'>
          {pageTitle}
        </Typography>
        {/* ToDo later */}
        {/* <Typography mb='32px'>
          {subTitle}
        </Typography> */}

        <Card>
          {researchPapers.length > 0 && researchPapers.filter((researchPaper) => researchPaper.display === true).map(({ title, description, publishedDateText }, index) => (
            <Stack
              border='1px solid'
              borderColor='primary.darkGray20'
              borderRadius='8px'
              direction='column'
              flexBasis='345px'
              maxWidth='345px'
              overflow='hidden'
              width='100%'
              key={title}
            >

              <Stack padding='30px' spacing='16px'>
                <Typography
                  color='primary.navy'
                  height='72px'
                  overflow='hidden'
                  textOverflow='ellipsis'
                  variant='h5'
                >
                  {title}
                </Typography>
                {publishedDateText && (
                  <Typography
                    color='primary.darkGray'
                    fontSize='14px'
                    fontWeight={500}
                  >
                    {publishedDateText}
                  </Typography>
                )}

                <Typography
                  display='-webkit-box'
                  color='primary.navy'
                  maxHeight='100px'
                  overflow='hidden'
                  textOverflow='ellipsis'
                >
                  {description}
                </Typography>

                <Link
                  style={{ textDecoration: 'none' }}
                  to={`/welcome/study-updates/${index}`}
                >
                  <Typography
                    color='primary.green'
                    fontWeight={700}
                    sx={{ textDecoration: 'underline' }}
                  >
                    {readMore}
                  </Typography>
                </Link>
              </Stack>
            </Stack>
          ))}
        </Card>
      </WelcomePageWrapper>
    </>
  );
}
